<template>
    <div>
        <!--Top Menu -->
        <intra-top></intra-top>

        <!-- Contents -->
        <div class="row justify-content-center" style="min-width:550px;">
            <div class="row">
                <h2 class="card-title" style="font-weight:bold;margin:8px 0 -8px 0;"><i class="fas fa-square"></i> 사원 상세보기</h2>    
                <div class="card-body">
                    <div class="table-responsive table-bordered">
                        <table class="table">
                            <colgroup>
                                <col style="width:110px" />
                                <col style="" />
                                <col style="width:110px" />
                                <col style="" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th class="table-active w110">ID</th>
                                    <td class="txtL" style="min-width:130px;">{{employee.user_id}}</td>
                                    <td rowspan="7" colspan="2" style="">
                                        <img :src="'/img/emp_pic/'+employee.user_pic" style="max-width:200px;"/>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="table-active w110">사원번호</th>
                                    <td class="txtL">{{employee.emp_no}}</td>
                                </tr>
                                <tr>
                                    <th class="table-active w110">이름</th>        
                                    <td class="txtL">{{employee.user_name}}</td>
                                </tr>
                                <tr>
                                    <th class="table-active w110">부서</th>
                                    <td class="txtL">{{employee.dept_name}}</td>
                                </tr>
                                <tr>
                                    <th class="table-active w110">직급</th>
                                    <td class="txtL">{{employee.posi_name}}</td>
                                    
                                </tr>
                                <tr>
                                    <th class="table-active w110">근무여부</th>
                                    <td class="txtL">{{employee.use_yn_name}}</td>
                                </tr>
                                <tr>
                                    <th class="table-active w110">권한</th>
                                    <td class="txtL">{{employee.grant_name}}</td>
                                </tr>
                                <tr>
                                    <th class="table-active w110">입사일자</th>
                                    <td class="txtL">{{employee.enter_dt}}</td>
                                    <th class="table-active w110">퇴사일자</th>
                                    <td class="txtL">{{employee.resign_dt}}</td>
                                </tr>
                                <tr>
                                    <th class="table-active w110">전화번호</th>
                                    <td class="txtL">{{employee.tel_no}}</td>
                                    <th class="table-active w110">모바일</th>
                                    <td class="txtL">{{employee.mobile_tel_no}}</td>
                                </tr>
                                <tr>
                                    <th class="table-active w110">이메일</th>    
                                    <td class="txtL" colspan="3">{{employee.e_mail}}</td>
                                </tr>
                                
                                <tr>
                                    <th class="table-active w110">주소</th>
                                    <td colspan="3" class="txtL">
                                        ({{employee.zip_code}}) {{employee.addr1}}
                                    </td>
                                </tr>
                                <tr>
                                    <th class="table-active w110">등록일자</th>
                                    <td class="txtL">{{employee.reg_dt}}</td>
                                    <th class="table-active w110">수정일자</th>
                                    <td class="txtL">{{employee.upt_dt}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>    

            <div class="justify-content-between">
                <button type="button" class="btn btn-success" @click="goList">목록</button>
                <button type="button" class="btn btn-success" @click="userModify" style="margin-left:8px">수정</button>
                
            </div>
        </div>   
    </div>
</template>



<script type="text/javascript">
import Constant from '../../Constant';
import { mapState } from 'vuex';
import IntraTop from './IntraTop';
//import axios from 'axios';

export default { 
    name : 'user-detail',
    components : { IntraTop},
    beforeCreate: function(){
        console.log('UserDetail beforeCreate...');
        //this.$store.dispatch(Constant.BOARD_DETAIL, this.nttId);
        /*
        if(this.$store.state.uid == "UID"){
            console.log("before:UID:" + this.$store.state.uid);
            this.$router.push('login');
        }
        else{
            console.log("before:UID:" + this.$store.state.uid);
        }
        */
    },
    
    //props : ['boardId', 'nttId'],
    computed: {
       ...mapState([ 'employee' ]),
    },
    methods: {
       
        goList: function(){
            this.$router.go(-1);
        },
        userModify: function(){
            this.$store.dispatch(Constant.USER_MODIFY);
        },
        
    },
    mounted : function(){
        //console.log("mounted::" + this.boardId);
        //console.log("mounted::" + this.boardMode);
    }
    
}

</script>